import { render, staticRenderFns } from "./ApplicationUploadsDashboard.vue?vue&type=template&id=ac9311b4&scoped=true&"
import script from "./ApplicationUploadsDashboard.vue?vue&type=script&lang=js&"
export * from "./ApplicationUploadsDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac9311b4",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardText,VCol,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ac9311b4')) {
      api.createRecord('ac9311b4', component.options)
    } else {
      api.reload('ac9311b4', component.options)
    }
    module.hot.accept("./ApplicationUploadsDashboard.vue?vue&type=template&id=ac9311b4&scoped=true&", function () {
      api.rerender('ac9311b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/uploads/components/ApplicationUploadsDashboard.vue"
export default component.exports